<template lang="pug">
  v-app(style='background: #FFFFFF !important;')
    v-container(fluid, grid-list-xl)
      v-content
        v-layout(row, justify-center)
          v-flex(xs12, sm12, md10, lg9)
            v-card(flat, text-xs-center)
            breadcrumb(back='page10-6')
              v-card-text.label16tt.withDivider
                | LECCIÓN: ELIGE TU CRÉDITO HIPOTECARIO
              .titulo36Book.pa-0.ma-0.px-5
                b Descubre más oportunidades ...
            v-layout(row, wrap, justify-start, py-4)
              v-flex.ma-0.pa-0(xs12, md8)
                v-card.px-4(flat, height='100%')
                  v-card-text.parrafoDestacado18.py-0.pt-4
                    v-layout(row, wrap, justify-start, py-4)
                      v-flex.ma-0.pa-0(xs12, md3)
                        img(src='assets/simuladorTCH.gif' height=128 width=128)
                      v-flex.ma-0.pa-0.pt-4.pl-4(xs12, md9)
                        b Lleva los conocimientos que adquiriste a otro nivel con nuestro: 
                        br
                        a(href="https://www.bancomer.com/personas/productos/creditos/credito-hipotecario.html" target="_blank" style='color:#2A86CA') Simulador de Crédito Hipotecario.
                  v-card-text.parrafoDestacado18.py-0.pt-4
                    v-layout(row, wrap, justify-start, py-4)
                      v-flex.ma-0.pa-0(xs12, md3)
                        img(src='assets/BlogEF.gif'  height=128 width=128)
                      v-flex.ma-0.pa-0.pt-4.pl-4(xs12, md9)
                        b ¿Quieres aprender más? 
                        br
                        | Complementa tu aprendizaje en el 
                        br
                        a(href="https://www.educacionfinancierabancomer.com/Blog"  target="_blank" style='color:#2A86CA') Blog de Educacion Financiera  
                  v-card-text.parrafoDestacado18.py-0
              v-flex.ma-0.pa-0(xs12, md4)
                v-card.pa-4(flat, text-xs-start, height='100%', color='accent')
                  v-card-text.titulo24Book.pt-4.mt-2.px-4
                    b(style="color:white") También te recomendamos: 
                  v-card-text.parrafoDestacado18.py-3.px-4
                    a(href="https://bbva.blackboard.com/webapps/blackboard/content/listContent.jsp?course_id=_438_1&content_id=_864_1" target="_blank" style="color:white") Micro taller - Ahorro
                  v-card-text.parrafoDestacado18.py-3.px-4
                    a(href="https://bbva.blackboard.com/webapps/blackboard/content/listContent.jsp?course_id=_440_1&content_id=_872_1" target="_blank" style="color:white") Micro taller - Banca Digital
                  v-card-text.parrafoDestacado18.py-3.px-4
                    a(href="https://bbva.blackboard.com/webapps/blackboard/content/listContentEditable.jsp?content_id=_879_1&course_id=_441_1" target="_blank" style="color:white") Micro taller - Tarjeta de Crédito
                  v-card-text.parrafoDestacado18.py-3.px-4
                    a(href="https://bbva.blackboard.com/webapps/blackboard/content/listContent.jsp?course_id=_442_1&content_id=_886_1" target="_blank" style="color:white") Micro taller - Aprovecha tu Tarjeta de Crédito
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="finish('NoPayload')")
                | Finalizar
            l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    },
    finish() {
      this.progress = true;
      eventBus.$emit('finish');
    },
  }
};
</script>
